import { Dialog } from "primereact/dialog";
import "./ShipmentDetailsPopup.scss";
import closeIcon from "../../../../assets/images/close-outline.svg";
import infoIcon from "../../../../assets/images/tootipInfoIcon.svg";

const getEachRowData = (label, value) => (
  <div className="details-row">
    <div className="details-label">{`${label}:`}</div>
    <div className="details-value">{value || ""}</div>
  </div>
);

const getWeightUnitValue = (value) => {
  if (value === "K") return "kg";
  if (value === "L") return "lb";
  if (value === "T") return "t";
  return "";
};

const LABELS = {
  ROUTE: "Route",
  ROUTING: "Routing",
  SCC_CODES: "SCC Codes",
  PIECES: "Pieces",
  SLAC: "SLAC",
  WEIGHT: "Weight",
  WEIGHT_UNIT: "Weight Unit",
  HS_CODES: "HS Codes",
  PRODUCT: "Product",
  GOODS_IDENTIFIER: "Goods Identifier/Shipment Description",
  SHIPMENT_DESCRIPTION: "Shipment Description",
  OCI_INFO_DETAILS: "OCI Info Details",
  SHIPPER_DETAILS: "Shipper Details",
  CONSIGNEE_DETAILS: "Consignee Details",
  NAME: "Name",
  ADDRESS: "Address",
  PHONE: "Phone",
  ZIP: "Zip",
};

const getShipmentDescription = (shipmentDescription, description, isAwb) =>
  isAwb ? (
    <div className="details-row">
      <div className="details-label">{LABELS.GOODS_IDENTIFIER}:</div>
      <ul className="details-value">
        {shipmentDescription?.map((item, idx) => (
          <li key={item?.code || idx}>
            {item?.code}/{item?.description}
          </li>
        ))}
      </ul>
    </div>
  ) : (
    getEachRowData(LABELS.SHIPMENT_DESCRIPTION, description)
  );

export const ShipmentDetailsPopup = ({ headerData, shipmentData, onClose }) => {
  const {
    origin = "N/A",
    destination = "N/A",
    routing = "N/A",
    sccCodes = [],
    pices = "N/A",
    weight = "N/A",
    weightUnit = "",
    shipmentDescription = [],
    product = "N/A",
    slacPices = "N/A",
    hsCodes = [],
    ociInfoDetails = [],
    shipperDetails = null,
    consigneeDetails = null,
    description = "N/A",
  } = shipmentData || {};

  return (
    <div className="cargo-portal-container dialog-container">
      <div className="portal-dialog p-fluid">
        <Dialog
          visible
          modal
          closable={true}
          showHeader={false}
          className="shipment-details-dialog"
        >
          <div className="shipment-details-container">
            <div className="shipment-details-header">
              <div className="d-flex flex-row align-items-center">
                <img
                  src={infoIcon}
                  alt="Information Icon"
                  className="info-icon"
                />
                {`${
                  headerData?.isAwb
                    ? `MAWB - ${headerData?.awbNo}`
                    : `${headerData?.awbNo} | HAWB - ${headerData?.hawb}`
                }`}
              </div>
              <img
                src={closeIcon}
                className="close-button"
                alt="Close Icon"
                onClick={onClose}
              />
            </div>
            {!shipmentData ? (
              <div className="details-row no-data">
                <div className="details-value">{t('PLACI_DASHBOARD.NO_SHIPMENT_DATA')}</div>
              </div>
            ) : (
              <>
                <hr className="my-2" />
                <div className="shipment-details-data">
                  <div className="top-row">
                    <div className="row-group">
                      {getEachRowData(
                        LABELS.ROUTE,
                        origin && destination
                          ? `${origin} ➝ ${destination}`
                          : ""
                      )}
                      {headerData?.isAwb &&
                        getEachRowData(LABELS.ROUTING, routing)}
                      {getEachRowData(LABELS.SCC_CODES, sccCodes?.join(", "))}
                      {getEachRowData(LABELS.PIECES, pices)}
                      {getEachRowData(LABELS.SLAC, slacPices)}
                      {getEachRowData(
                        LABELS.WEIGHT,
                        `${weight || ""} ${
                          weightUnit ? getWeightUnitValue(weightUnit) : ""
                        }`
                      )}
                      {getEachRowData(LABELS.HS_CODES, hsCodes?.join(", "))}
                      {headerData?.isAwb &&
                        getEachRowData(LABELS.PRODUCT, product)}
                      {getShipmentDescription(
                        shipmentDescription,
                        description,
                        headerData?.isAwb
                      )}
                      <div className="details-row">
                        <div className="details-label">
                          {LABELS.OCI_INFO_DETAILS}:
                        </div>
                        <ul className="details-value">
                          {ociInfoDetails?.map((oci, idx) => (
                            <li key={oci?.isoCountryCode || idx}>
                              {oci?.isoCountryCode}
                              {oci?.infoIdentifier && `/${oci?.infoIdentifier}`}
                              {oci?.csrcInfoIdentifier &&
                                `/${oci?.csrcInfoIdentifier}`}
                              {oci?.supplementaryCSRCId &&
                                `/${oci?.supplementaryCSRCId}`}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="address-row">
                    <div className="address-details">
                      <div className="section-label">
                        {LABELS.SHIPPER_DETAILS}:
                      </div>
                      <div className="sub-label">{LABELS.NAME}:</div>
                      {shipperDetails?.name || ""}
                      <br />
                      <div className="sub-label">{LABELS.ADDRESS}:</div>
                      {shipperDetails?.address || ""}
                      <br />
                      {shipperDetails?.city}
                      {shipperDetails?.state &&
                        `${shipperDetails?.city ? ", " : ""}${
                          shipperDetails?.state || ""
                        }`}
                      {shipperDetails?.country &&
                        `${
                          shipperDetails?.state || shipperDetails?.city
                            ? ", "
                            : ""
                        }${shipperDetails?.country || " "}`}
                      <br />
                      {LABELS.PHONE}: {shipperDetails?.phone || ""} <br />
                      {LABELS.ZIP}: {shipperDetails?.zipCode || ""}
                    </div>
                    <div className="address-details">
                      <div className="section-label">
                        {LABELS.CONSIGNEE_DETAILS}:
                      </div>
                      <div className="sub-label">{LABELS.NAME}:</div>
                      {consigneeDetails?.name || ""}
                      <br />
                      <div className="sub-label">{LABELS.ADDRESS}:</div>
                      {consigneeDetails?.address || ""}
                      <br />
                      {consigneeDetails?.city}
                      {consigneeDetails?.state &&
                        `${consigneeDetails?.city ? ", " : ""}${
                          consigneeDetails?.state || ""
                        }`}
                      {consigneeDetails?.country &&
                        `${
                          consigneeDetails?.state || consigneeDetails?.city
                            ? ", "
                            : ""
                        }${consigneeDetails?.country || ""}`}
                      <br />
                      {LABELS.PHONE}: {consigneeDetails?.phone || ""} <br />
                      {LABELS.ZIP}: {consigneeDetails?.zipCode || ""}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Dialog>
      </div>
    </div>
  );
};
